import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal/Modal";
import "./Help.scss";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
export interface HelpInterface {
  help: HelpType;
  setHelp: React.Dispatch<React.SetStateAction<HelpType>>;
}

export enum HelpType {
  LANDING,
  NONE,
  TASKS,
  CREATE_TASK,
  TASK_DETAILS,
  IMAGES,
}

const images_map = {
  [HelpType.LANDING]: require("../../images/guide/1.png"),
  [HelpType.TASKS]: require("../../images/guide/2.png"),
  [HelpType.CREATE_TASK]: require("../../images/guide/3.png"),
  [HelpType.TASK_DETAILS]: require("../../images/guide/4.png"),
  [HelpType.IMAGES]: require("../../images/guide/2.png"),
  [HelpType.NONE]: require("../../images/guide/4.png"),
};

export const Help = ({ help, setHelp }: HelpInterface) => {
  return (
    <Modal open={help !== HelpType.NONE} onClose={() => setHelp(HelpType.NONE)}>
      <Box className="help-modal">
        <img src={images_map[help]} alt="Help" />
        <p>Version: {process.env.REACT_APP_VERSION}</p>
          
        <CloseIcon onClick={() => setHelp(HelpType.NONE)} className="close-icon" />
      </Box>
    </Modal>
  );
};
